import { render, staticRenderFns } from "./ForgottenPassDialog.vue?vue&type=template&id=6f09ee53"
import script from "./ForgottenPassDialog.vue?vue&type=script&lang=js"
export * from "./ForgottenPassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports